export var InputPhoneVariant;
(function (InputPhoneVariant) {
    InputPhoneVariant["REGULAR_WITH_PREFIX_DROPDOWN"] = "REGULAR_WITH_PREFIX_DROPDOWN";
    /**
     * @deprecated
     * This prop shouldnt be used. Use REGULAR_WITHOUT_PREFIX_DROPDOWN_V2 instead.
     */
    InputPhoneVariant["REGULAR_WITHOUT_PREFIX_DROPDOWN"] = "REGULAR_WITHOUT_PREFIX_DROPDOWN";
    InputPhoneVariant["REGULAR_WITHOUT_PREFIX_DROPDOWN_V2"] = "REGULAR_WITHOUT_PREFIX_DROPDOWN_V2";
})(InputPhoneVariant || (InputPhoneVariant = {}));
//# sourceMappingURL=variants.js.map